import React from 'react';
import { useNavigate } from 'react-router-dom';
import { styles } from './Workbench.styles';
import EntityTabsContainer from '../components/workbench/EntityTabsContainer';

const ClaimCreate = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      {/* Thin Actions Bar on the Left */}
      <div style={styles.actionsBar}>
        {/* Progress Circle */}
        <div style={styles.progressContainer}>
          <div style={styles.progressInner}>
            0%
          </div>
          <div style={styles.progressCircle}></div>
          <button style={styles.viewAllTasksButton}>
            VIEW ALL<br />TASKS
          </button>
        </div>

        {/* Divider */}
        <div style={styles.divider}></div>

        {/* Documents Button */}
        <div style={styles.actionButton}>
          <div style={styles.actionIcon}>
            📄
          </div>
          <span style={styles.actionLabel}>Documents</span>
        </div>

        {/* Claim Button */}
        <div style={{...styles.actionButton, cursor: 'pointer'}}>
          <div style={styles.actionIcon}>
            📋
          </div>
          <span style={styles.actionLabel}>Claim</span>
        </div>

        {/* Policy Button */}
        <div style={styles.actionButton}>
          <div style={styles.actionIcon}>
            🛡️
          </div>
          <span style={styles.actionLabel}>Policy</span>
        </div>

        {/* Profile Button */}
        <div style={styles.actionButton}>
          <div style={styles.actionIcon}>
            👤
          </div>
          <span style={styles.actionLabel}>Profile</span>
        </div>
      </div>

      {/* Main Content Area */}
      <div style={styles.mainContent}>
        {/* Header Section */}
        <div style={{
          background: '#ffffff',
          borderRadius: '12px',
          padding: '1.5rem',
          marginBottom: '1rem',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
        }}>
          <h1 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#1f2937',
            margin: 0
          }}>
            Create New Claim
          </h1>
          <p style={{
            fontSize: '0.875rem',
            color: '#6b7280',
            margin: '0.5rem 0 0 0'
          }}>
            Enter claim details below. All fields marked with * are required.
          </p>
        </div>

        {/* Back Navigation */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          marginBottom: '1rem'
        }}>
          <button 
            onClick={() => navigate(-1)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.3rem',
              border: 'none',
              background: 'transparent',
              color: '#64748b',
              fontSize: '0.95rem',
              cursor: 'pointer',
              padding: '0.3rem 0.5rem',
              borderRadius: '4px',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f1f5f9'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <span style={{ fontSize: '1.2rem' }}>‹</span>
            <span style={{ fontWeight: '500' }}>Back</span>
          </button>
        </div>

        {/* Entity Tabs with Dynamic Forms - Pass null for claimId to enable creation mode */}
        <EntityTabsContainer claimId={null} isCreateMode={true} />
      </div>
    </div>
  );
};

export default ClaimCreate;
